import fr from './fr.json';
import en from './en.json';
import it from './it.json';
import es from './es.json';
import pt from './pt.json';
import de from './de.json';

const messages = {
    fr,
    en,
    it,
    es,
    pt,
    de
};
export default messages;